export const scrollToPhase = ({
  index,
  phaseContainerRef,
  timelineRef,
  scrollIntoView,
}: {
  index: number;
  phaseContainerRef: React.RefObject<HTMLDivElement>;
  timelineRef: React.RefObject<HTMLDivElement>;
  scrollIntoView?: boolean;
}) => {
  if (!phaseContainerRef.current) return;
  if (!timelineRef.current) return;

  const timelineContainer = timelineRef.current;

  const timelinePhase = timelineContainer.children[index] as HTMLElement;

  const phaseContainer = phaseContainerRef.current;

  const phase = phaseContainer.children[index] as HTMLElement;

  if (!phase) return;

  // Get bounding rects for accurate positioning
  const containerRect = phaseContainer.getBoundingClientRect();
  const phaseRect = phase.getBoundingClientRect();

  const timelineRect = timelineContainer.getBoundingClientRect();
  const timelinePhaseRect = timelinePhase.getBoundingClientRect();

  // Calculate scroll position using bounding rects
  const phaseCenter = phaseRect.left + phaseRect.width / 2;
  const containerCenter = containerRect.left + containerRect.width / 2;
  const scrollOffset =
    phaseContainer.scrollLeft + (phaseCenter - containerCenter);

  const timelineCenter = timelinePhaseRect.left + timelinePhaseRect.width / 2;
  const timelineContainerCenter = timelineRect.left + timelineRect.width / 2;
  const timelineOffset =
    timelineContainer.scrollLeft + (timelineCenter - timelineContainerCenter);

  if (scrollIntoView) {
    phase.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });

    timelineContainer.scrollTo({
      left: timelineOffset,
      top: 0,
      behavior: "smooth",
    });
  } else {
    phaseContainer.scrollTo({
      left: scrollOffset,
      top: 0,
      behavior: "smooth",
    });
  }
};

export default scrollToPhase;
